import React from 'react';
import { Tag } from 'antd';

// const PaymentStatus = {
//   PENDING: "pending",
//   PAID: "paid",
//   REFUND: "refund",
// };

// export const paymentStatus = Object.keys(PaymentStatus).map((key) => ({
//   value: PaymentStatus[key],
//   label: key,
// }));

export const paymentStatus = [
  { value: 'pending', label: 'Non Payé' },
  { value: 'paid', label: 'Payé' },
  { value: 'refund', label: 'Remboursé' },
];

export const getTagPaymentStatus = (record) => {
  switch (record.pay_status) {
    case 'pending':
      return <Tag color="gold">Pending</Tag>;
    case 'deposited':
      return <Tag color="green">Deposited</Tag>;
    case 'paid':
      return <Tag color="blue">Paid</Tag>;
    default:
      return <Tag color="purple">Refund</Tag>;
  }
};
